import { render, staticRenderFns } from "./RegisterBank.vue?vue&type=template&id=189c272b"
import script from "./RegisterBank.vue?vue&type=script&lang=js"
export * from "./RegisterBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports